<template>
  <div id="popupModal">
    <div class="popupModalBody">
      <div id="close" @click="onClickClosePopup">
        <font-awesome-icon icon="times" />
      </div>
      <div class="popupModalTitle">Set Password</div>
      <div class="popupModalDescription">
        <div class="left">
          Your new password must include the following:
          <ul>
            <li>At least 8 characters in length</li>
            <li>At least 1 uppercase letter</li>
            <li>At least 1 lowercase letter</li>
            <li>At least 1 number</li>
            <li>At least 1 special character: ~`!@#$%^&*()-_+={}[]|\;:"<>,./?</li>
          </ul>
        </div>
        <div class="right">
          <div class="formRow">
            <label for="password">New Password</label>
            <input
              type="password"
              name="password"
              minlength="8"
              required
              v-model="password"
            />
          </div>
          <div class="formRow">
            <label for="password2">Re-Type New Password</label>
            <input
              type="password"
              name="password2"
              minlength="8"
              required
              v-model="password2"
            />
          </div>
        </div>
      </div>
      <div class="popupModalFooter">
        <button @click="passwordContinue">Continue</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["settings"],
  data() {
    return {
      password: null,
      password2: null
    };
  },
  methods: {
    async passwordContinue() {
      let passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!@#$%^&*()-_+={}[]|\\;:"<>,.\/?])[A-Za-z\d~`!@#$%^&*()-_+={}[]|\\;:"<>,.\/?]{8,30}$/;

      if(this.password.match(passwordRegex) !== null && this.password2.match(passwordRegex) !== null && this.password === this.password2){

        
        const updateUserPasswordRes = await axios.post(`user/updateUserPassword`, {
          password: this.password,
          userId: this.$store.state.user.user.id
        });

        if(updateUserPasswordRes.data.success){
          this.$swal(
            "Success!",
            "You have successfully updated your password",
            "success"
          );
          this.$emit("changePasswordStatus", 'complete');
        }
      }else{
        this.$swal(
          "Error!",
          "Your password doesn't match or the format is invalid",
          "error"
        );
      }
    },
    onClickClosePopup() {
      this.$store.state.user.user.agreedTerm = null;
      this.$emit("changePasswordStatus", false);
    },
    async handleUserChange(newVal) {
      let userId = newVal.id;
      window.console.log("newVal.isActive", newVal.isActive);

      const updateTopicUserStatusRes = await axios.post(
        `admin/updateTopicUserStatus`,
        {
          topic: this.userModalProps,
          user_id: userId,
          active: newVal.isActive,
        }
      );
    },
    async init() {
      try {
        //const getUsersRes = await axios.get(`admin/getUsers`);
        //this.users = getUsersRes.data;
        //this.users.forEach(user => {
        //   this.$set(user, 'isActive', false)
        //});
        //const getUsersByTopicIdRes = await axios.get(`admin/getUsersByTopicId/${this.userModalProps}`);
        //getUsersByTopicIdRes.data.forEach(TopicUser => {
        //    let user = this.users.find(user => user.id == TopicUser.userId)
        //    user.isActive = TopicUser.isActive;
        //});
        //window.console.log(this.users);
        //this.users.forEach((val) => {
        //    this.$watch(() => val, this.handleUserChange, {deep: true});
        //});
      } catch (e) {
        window.console.log(e);
      }
      this.isLoading = false;
    },
  },
  mounted() {},
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
#popupModal {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  #close {
    background: #ff6262;
    border-radius: 4px 4px 0 0;
    width: 37px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 18px;
    bottom: 100%;
    cursor: pointer;

    svg {
      color: #ffffff;
      font-size: 23px;
    }
  }
  .checkbox {
    .checkboxCol {
      display: flex;
      align-items: center;
      input {
        height: auto;
      }
      margin-left: 30px;
      &:first-child {
        margin-left: 0px;
      }
      span {
        font-family: Effra-Medium;
        font-size: 13px;
        color: #000000;
        letter-spacing: 0;
        margin-left: 13px;
      }
    }
    .checkboxCol {
      display: inline-flex;
      cursor: pointer;
      position: relative;
      & > span {
        //color: #3d3d3d;
        padding: 0.5rem 0.25rem;
      }
      & > input {
        height: 25px;
        width: 25px;
        appearance: none;
        border: 1px solid #009ad6;
        border-radius: 4px;
        outline: none;
        transition-duration: 0.3s;
        background-color: #ffffff;
        cursor: pointer;
      }
      & > input:checked {
        border: 1px solid #ffffff;
        background-color: #009ad6;
        border-radius: 50%;
      }

      & > input:checked + span::before {
        content: "\2713";
        display: block;
        text-align: center;
        color: #ffffff;
        position: absolute;
        left: 8px;
        top: 9px;
        pointer-events: none;
      }

      & > input:active {
        border: 2px solid #3d3d3d;
      }
    }
  }
  .popupModalBody {
    background-image: linear-gradient(180deg, #f6f6f6 0%, #ffffff 100%);
    box-shadow: 0 4px 67px 0 rgba(0, 0, 0, 0.13);
    border-radius: 8px;
    max-width: 733px;
    width: 100%;
    padding: 50px;
    position: relative;
    .popupModalTitle {
      font-family: Effra-Light;
      font-size: 30px;
      color: #009ad6;
      letter-spacing: 0;
      line-height: 44px;
      margin-bottom: 13px;
    }
    .popupModalDescription {
      font-family: Effra-Regular;
      font-size: 13px;
      color: #5F5F5F;
      letter-spacing: 0;
      line-height: 19px;
      display: flex;
      justify-content: space-between;

      .left,
      .right{
        width: 50%;
      }

      ul {
        padding-left: 15px;
        li {
          padding-left: 0px;
          margin-top: 5px;
          margin-bottom: 5px;
        }
      }
      .formRow{
        display: flex;
        flex-direction: column;
        &:last-child{
          margin-top: 10px;
        }
        label{
          font-family: Effra-Medium;
          font-size: 13px;
          color: #000000;
          letter-spacing: 0;
        }
        input{
          background: #EAEAEA;
          border-radius: 5px;
          height: 36px;
          border: 0px;
          padding: 0 10px
        }
      }
    }
  }
  .popupModalFooter {
    display: flex;
    border-top: 2px solid #009ad6;
    margin-top: 20px;
    padding-top: 25px;
    align-items: center;
    justify-content: flex-end;
  }
  button {
    background: #009ad6;
    border-radius: 4px;
    font-family: Effra-Medium;
    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    line-height: 23px;
    padding: 4px 36px;
    border: 0;
  }
}
</style>